var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 28 28",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".warning_svg__st0{fill:#f55524}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_svg___x2F_\\u4EA7\\u54C1\\u9884\\u8BA2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__\\u5207\\u56FE",
    transform: "translate(-143 -166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__ic_\\u95EE\\u9898",
    transform: "translate(145 168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "warning_svg__st0",
    d: "M12,24.5C5.1,24.5-0.5,18.9-0.5,12S5.1-0.5,12-0.5S24.5,5.1,24.5,12S18.9,24.5,12,24.5z M12,0.5 C5.7,0.5,0.5,5.7,0.5,12c0,6.3,5.2,11.5,11.5,11.5c6.3,0,11.5-5.2,11.5-11.5C23.5,5.7,18.3,0.5,12,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "warning_svg__Combined-Shape",
    className: "warning_svg__st0",
    d: "M14,17.5c0,0.8-0.7,1.5-1.5,1.5S11,18.3,11,17.5s0.7-1.5,1.5-1.5S14,16.7,14,17.5z M12.5,5C13.3,5,14,5.7,14,6.5v6c0,0.8-0.7,1.5-1.5,1.5S11,13.3,11,12.5v-6C11,5.7,11.7,5,12.5,5z"
  })))))));
};
export default SvgWarning;